import Spinner from 'components/spinner/SpinnerIE';
import { msieversion } from 'helpers/commonHelper';
import withProgressBar from 'hoc/withProgressBar';
import React, { createRef, PureComponent, RefObject } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  FastRedirectProgressRing,
  PendingScreenContainer,
  PendingScreenSpinner,
  PendingScreenText,
  ProgressRingCircle,
  ProgressRingPlaceholder,
  ProgressRingSvg,
} from './PendingScreen.styles';

interface IPendingScreenProps {
  fastRedirect: boolean;
}

class PendingScreen extends PureComponent<
  IPendingScreenProps & Partial<IContext> & Partial<ITextContext>,
  { strokeDashoffset?: number }
> {
  progressRing: RefObject<SVGCircleElement> = createRef();

  constructor(props) {
    super(props);
    this.state = {
      strokeDashoffset: 0,
    };
  }

  componentDidMount() {
    const { setPaymentStatusText } = this.props;
    if (setPaymentStatusText) {
      setPaymentStatusText('payment.status.title', '');
    }
  }

  componentDidUpdate() {
    const { fastRedirect } = this.props;
    if (fastRedirect && this.progressRing.current) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        strokeDashoffset: parseInt(getComputedStyle(this.progressRing.current).strokeDashoffset || '0', 10),
      });
    }
  }

  render() {
    const { fastRedirect } = this.props;
    const { strokeDashoffset } = this.state;

    return (
      <PendingScreenContainer className="pending-screen__container">
        {msieversion() ? (
          <Spinner isLoading />
        ) : (
          <PendingScreenSpinner>
            <ProgressRingSvg>
              <ProgressRingPlaceholder />
            </ProgressRingSvg>
            <ProgressRingSvg>
              <ProgressRingCircle ref={this.progressRing} />
              {fastRedirect && <FastRedirectProgressRing strokeDashoffset={strokeDashoffset as number} />}
            </ProgressRingSvg>
          </PendingScreenSpinner>
        )}
        <PendingScreenText>
          <FormattedMessage id="payment.status.description" />
        </PendingScreenText>
      </PendingScreenContainer>
    );
  }
}

export default withProgressBar(0)(PendingScreen);
